((window) => {
    const carousels = [...document.querySelectorAll('[data-behaviour="news-carousel"]')];

    if (!carousels.length) return;

    carousels.forEach((carousel) => {
        const viewport = carousel.querySelector("[data-news-carousel-viewport]");
        const track = carousel.querySelector("[data-news-carousel-track]");
        const prev = carousel.querySelector("[data-news-carousel-prev]");
        const next = carousel.querySelector("[data-news-carousel-next]");

        if (!viewport || !track) return;

        let offset = 0;

        // Real scrollable distance — clamps navigation to the content bounds so
        // it can never overshoot into blank space (the bug with the shared
        // paginated-slides component inside the 120% bleed wrapper).
        // The viewport is intentionally wider than the screen (the 120% bleed),
        // so measure the *on-screen* width (viewport-left → screen-right) to keep
        // the final card reachable into the visible area.
        const maxScroll = () => {
            const rect = viewport.getBoundingClientRect();
            const visibleWidth = Math.min(
                viewport.clientWidth,
                window.innerWidth - rect.left
            );

            return Math.max(0, track.scrollWidth - visibleWidth);
        };

        // One card (+ the flex gap) per click.
        const step = () => {
            const slide = track.children[0];

            if (!slide) return viewport.clientWidth;

            const styles = getComputedStyle(track);
            const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;

            return slide.getBoundingClientRect().width + gap;
        };

        const update = () => {
            offset = Math.max(0, Math.min(offset, maxScroll()));
            track.style.transform = `translateX(-${offset}px)`;

            if (prev) prev.disabled = offset <= 0;
            if (next) next.disabled = offset >= maxScroll() - 1;
        };

        if (prev) {
            prev.addEventListener("click", () => {
                offset -= step();
                update();
            });
        }

        if (next) {
            next.addEventListener("click", () => {
                offset += step();
                update();
            });
        }

        window.addEventListener("resize", update);

        update();
    });
})(window);
